import { render, staticRenderFns } from "./LevelFactorsProposals.vue?vue&type=template&id=0cd1a441"
import script from "./LevelFactorsProposals.vue?vue&type=script&lang=js"
export * from "./LevelFactorsProposals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports